export const SKIP = 'Skip';



// WEBPACK FOOTER //
// ./src/common/Components/ImportPreview/helpers/Constants.js